var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.025 0C5.384 0 0 5.3728 0 12C0 18.6272 5.384 24 12.025 24C18.666 24 24.05 18.6272 24.05 12C24.05 5.3728 18.666 0 12.025 0ZM12.025 23C5.94677 23 1.00208 18.0656 1.00208 12C1.00208 5.9344 5.94677 1 12.025 1C18.1029 1 23.0479 5.9344 23.0479 12C23.0479 18.0656 18.1029 23 12.025 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41481 11.8367C8.52169 11.8367 9.41898 10.9412 9.41898 9.83667C9.41898 8.7321 8.52169 7.83667 7.41481 7.83667C6.30794 7.83667 5.41064 8.7321 5.41064 9.83667C5.41064 10.9412 6.30794 11.8367 7.41481 11.8367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6345 11.8367C17.7414 11.8367 18.6387 10.9412 18.6387 9.83667C18.6387 8.7321 17.7414 7.83667 16.6345 7.83667C15.5277 7.83667 14.6304 8.7321 14.6304 9.83667C14.6304 10.9412 15.5277 11.8367 16.6345 11.8367Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0697 15.3117C13.819 17.5741 10.2131 17.5609 6.98154 15.3117C6.59274 15.0409 6.24201 15.5097 6.50575 15.9429C7.491 17.5617 9.47874 19.0029 12.0256 19.0029C14.5725 19.0029 16.5603 17.5613 17.5455 15.9429C17.8093 15.5097 17.4585 15.0413 17.0697 15.3117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.74385fea9a82ef2fc0754fba798a8560.svg";
export { ForwardRef as ReactComponent };